import { DefaultMantineColor, MantineColorsTuple } from '@mantine/core';

export type ExtendedCustomColors =
  | 'white'
  | 'black'
  | 'text'
  | 'creamorange'
  | 'purple'
  | 'secondary'
  | 'primary'
  | 'success'
  | 'pink'
  | 'danger'
  | DefaultMantineColor;

const colors: Partial<Record<ExtendedCustomColors, MantineColorsTuple>> = {
  white: [
    '#FFFFFF1A',
    '#FFFFFF33',
    '#FFFFFF4D',
    '#FFFFFF66',
    '#FFFFFF80',
    '#FFFFFF99',
    '#FFFFFFB3',
    '#FFFFFFCC',
    '#FFFFFFE6',
    '#FFFFFF'
  ],
  black: [
    '#0000001A',
    '#00000033',
    '#0000004D',
    '#00000066',
    '#00000080',
    '#00000099',
    '#000000B3',
    '#000000CC',
    '#000000E6',
    '#000000'
  ],
  blue: [
    '#EFF6FF',
    '#DDECFF',
    '#97C7FF',
    '#3D96FF',
    '#1173E6',
    '#0664B8',
    '#004E95',
    '#003F83',
    '#0A264B',
    '#0B1D35'
  ],
  text: [
    '#f5f5f5',
    '#e0e0e1',
    '#c1c1c3',
    '#9fa0a2',
    '#777879',
    '#4e4f51',
    '#222324',
    '#1b1c1d',
    '#141516',
    '#0d0e0e'
  ],
  secondary: [
    '#F9F9FA',
    '#F3F5F7',
    '#E4E7EC',
    '#C6CFD7',
    '#A1B0BE',
    '#7D93A6',
    '#5E6063',
    '#496075',
    '#2F445B',
    '#0C223B',
    '#F8F8F8',
    '#D9D9E0'
  ],
  primary: [
    '#EBF5FF',
    '#BFE0FF',
    '#93CBFF',
    '#66B6FF',
    '#389BF5',
    '#2580D3',
    '#1667B1',
    '#0A508F',
    '#023A6D',
    '#00274B'
  ],
  success: [
    '#FBFEFC',
    '#ECF8EF',
    '#82CA95',
    '#56B670',
    '#3F9256',
    '#2E6B3F',
    '#116329',
    '#044F1E',
    '#003D16',
    '#002D11'
  ],
  creamorange: [
    '#FEFAEC',
    '#FBF2CA',
    '#F8E48F',
    '#F5D565',
    '#F1BD2E',
    '#EA9E16',
    '#CF7810',
    '#AC5611',
    '#8C4214',
    '#733714'
  ],
  purple: [
    '#FBEFFF',
    '#ECD8FF',
    '#D8B9FF',
    '#C297FF',
    '#A475F9',
    '#8250DF',
    '#6639BA',
    '#512A97',
    '#3E1F79',
    '#2E1461'
  ],
  pink: [
    '#ffebed',
    '#fbd5d8',
    '#f1aaaf',
    '#e87b82',
    '#e1545d',
    '#dd3b45',
    '#dc2d39',
    '#cf222e',
    '#af1925',
    '#990c1e'
  ],
  danger: [
    '#FFEBE9',
    '#FFCECB',
    '#FFABA8',
    '#FF8182',
    '#FA4549',
    '#CF222E',
    '#A40E26',
    '#82071E',
    '#660018',
    '#4C0014'
  ],
  yellow: [
    '#FFF8C5',
    '#FAE17D',
    '#EAC54F',
    '#D4A72C',
    '#BF8700',
    '#9A6700',
    '#7D4E00',
    '#633C01',
    '#4D2D00',
    '#3B2300'
  ],
  orange: [
    '#FFF1E5',
    '#FFD8B5',
    '#FFB77C',
    '#FB8F44',
    '#E16F24',
    '#BC4C00',
    '#953800',
    '#762C00',
    '#5C2200',
    '#471700'
  ],
  violet: [
    '#F7EFFB',
    '#E6CDF2',
    '#DAB5EB',
    '#C993E2',
    '#BE7EDD',
    '#AE5ED4',
    '#9E56C1',
    '#7C4397',
    '#603475',
    '#492759'
  ],
  red: [
    '#FEF9FA',
    '#FBD6DA',
    '#F7ACB5',
    '#F38C99',
    '#F06979',
    '#EB3F54',
    '#E81F38',
    '#CB152B',
    '#AB1124',
    '#880E1D'
  ],
  gray: [
    '#FCFCFD',
    '#F7F7F8',
    '#EDEEEE',
    '#D6D7D8',
    '#B6B8BA',
    '#929599',
    '#74777B',
    '#484A4D',
    '#37383A',
    '#222324'
  ]
};

export { colors };

declare module '@mantine/core' {
  export interface MantineThemeColorsOverride {
    colors: Record<ExtendedCustomColors, MantineColorsTuple>;
  }
}
